import React from 'react';

export default function ChessyBrand({ className = '', withPlaygroundSuffix = false }) {
  return (
    <span className={`chessy-brand-text ${className}`.trim()}>
      Chessy <span className="chessy-brand-ai">AI</span>
      {withPlaygroundSuffix ? ' Playground' : ''}
    </span>
  );
}

